$(document).ready(function(){
  var slickCarousel = $('.blog-version');
  slickCarousel.slick({
      infinite: false,
      autoplay: false,
      speed: 300,
      slidesToShow: 6,
      slidesToScroll: 1,
      vertical: true,
      verticalSwiping: true,
      dots: false,
      centerPadding: '50px',
      arrows: false,
      responsive: [
          {
              breakpoint: 767,
              settings: {
                  slidesToShow: 6,
                  slidesToScroll: 2,
              }
          }
      ]
  });

  slickCarousel.mousewheel(function(e) {
    if ($(window).width() > 767) { 
        var currentIndex = slickCarousel.slick('slickCurrentSlide');
        var totalSlides = slickCarousel.slick('getSlick').slideCount;

        console.log(currentIndex + " == " + totalSlides);

        if (e.deltaY < 0 && currentIndex < totalSlides - 4) {
            e.preventDefault();
            $(this).slick('slickNext'); 
        }
        else if (e.deltaY > 0 && currentIndex > 0) {
            e.preventDefault();
            $(this).slick('slickPrev');
        }
      }
      var targetPost = $(this).find('.slick-active').attr('data-article');
      $('.in-view-article.slider-post').find('.article').removeClass('active');
      $('.in-view-article.slider-post').find('.article[data-article="'+targetPost+'"]').addClass('active');
  });


  $('.blog-version .blog-articles__article .article-card').click(function(){
    var targetDiv = $(this).closest('.blog-articles__article').attr('data-article');
    $('.in-view-article.slider-post').find('.article').removeClass('active');
    $('.in-view-article.slider-post').find('.article[data-article="'+targetDiv+'"]').addClass('active');
  });
  
});